import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReportParERechnungReadyStatus: 'idle',
    startReportParERechnungReadyError: undefined as any,
    loadUserParamsReportParERechnungReadyStatus: 'idle',
    loadUserParamsReportParERechnungReadyError: undefined as any,

    reportParERechnungReadyList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReportParERechnungReady = createAsyncThunk('reportParERechnungReadySlice/startReportParERechnungReady', async ({ reportParERechnungReady }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReportParERechnungReady/`,
        prepareData(reportParERechnungReady),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReportParERechnungReadyStatus } = getState().reportParERechnungReadySlice
        return startReportParERechnungReadyStatus !== 'pending'
    }
})

export const loadUserParamsReportParERechnungReady = createAsyncThunk('reportParERechnungReadySlice/loadUserParamsReportParERechnungReady', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReportParERechnungReady/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReportParERechnungReadyStatus } = getState().reportParERechnungReadySlice
        return loadUserParamsReportParERechnungReadyStatus !== 'pending'
    }
})

const ReportParERechnungReadySlice = createSlice({
    name: 'reportParERechnungReadySlice',
    initialState,
    reducers: {
        resetstartReportParERechnungReady: (state) => {
            state.job = undefined
            state.startReportParERechnungReadyError = undefined
        },
        resetstartReportParERechnungReadyError: (state) => {
            state.startReportParERechnungReadyError = undefined
        },
        resetloadUserParamsReportParERechnungReady: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReportParERechnungReadyError = undefined
        },
        resetloadUserParamsReportParERechnungReadyError: (state) => {
            state.loadUserParamsReportParERechnungReadyError = undefined
        },
        removeFromReportParERechnungReadyListById: (state, action) => {
            state.reportParERechnungReadyList = state.reportParERechnungReadyList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReportParERechnungReadyListByIds: (state, action) => {
            state.reportParERechnungReadyList = state.reportParERechnungReadyList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.reportParERechnungReadyList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReportParERechnungReadyStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.reportParERechnungReadyList = []
            state.startReportParERechnungReadyStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReportParERechnungReady.pending, (state) => {
            state.startReportParERechnungReadyStatus = 'pending'
            state.startReportParERechnungReadyError = undefined
        })
        builder.addCase(startReportParERechnungReady.fulfilled, (state, action) => {
            state.startReportParERechnungReadyStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReportParERechnungReady.rejected, (state, action) => {
            state.startReportParERechnungReadyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReportParERechnungReadyError = action.error.message
            } else {
                state.startReportParERechnungReadyError = action.payload
            }
        })

        builder.addCase(loadUserParamsReportParERechnungReady.pending, (state) => {
            state.loadUserParamsReportParERechnungReadyStatus = 'pending'
            state.loadUserParamsReportParERechnungReadyError = undefined
        })
        builder.addCase(loadUserParamsReportParERechnungReady.fulfilled, (state, action) => {
            state.loadUserParamsReportParERechnungReadyStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReportParERechnungReady.rejected, (state, action) => {
            state.loadUserParamsReportParERechnungReadyStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReportParERechnungReadyError = action.error.message
            } else {
                state.loadUserParamsReportParERechnungReadyError = action.payload
            }
        })

    }
})

export const {
    resetstartReportParERechnungReady,
    resetstartReportParERechnungReadyError,
    resetloadUserParamsReportParERechnungReady,
    resetloadUserParamsReportParERechnungReadyError,
    removeFromReportParERechnungReadyListById,
    removeFromReportParERechnungReadyListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ReportParERechnungReadySlice.actions
export default ReportParERechnungReadySlice.reducer
